import React, { useState, forwardRef,  useEffect } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import DataTable from 'react-data-table-component';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import SweetAlert2 from 'react-sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuReincorporados from './MenuReincorporados.jsx';
import { FaEraser } from 'react-icons/fa';
registerLocale('es', es);
setDefaultLocale('es');

export default function Desembolsos(){
    const { token, rol, user, sedeActual } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [swalProps, setSwalProps] = useState({});
    const [ayudas, setAyudas] = useState([]);
    const [entidades, setEntidades] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm({
        defaultValues: {
            sede: sedeActual
        }
    });
    const { desembolsosfields, append, remove } = useFieldArray({
        control,
        name: 'desembolsosfields'
      });
    function Borrardesesmbolso (row){
        remove(getValues('desembolsosfields').indexOf(row));
    };
    const entidad = watch('entidad');
    const [cabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
    });
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="custom-input" onClick={onClick} ref={ref}>
            <input value={value} readOnly className='widthCalendar'/>
            <i className="fa fa-calendar"></i>
        </div>
    ));
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button onClick={() => Borrardesesmbolso(row)} 
                        style={{backgroundColor: 'red'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Borrar">
                    <FaEraser size={20} color='white'/>
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Ayuda', selector: row => row.ayuda, sortable: true, width:'10%' },
        { name: 'Identificación', selector: row => row.idpersona, sortable: true, width: '15%'},
        { name: 'Entidad', selector: row => row.entidad, sortable: true, width: '15%' },
        { name: 'Cantidad', selector: row => row.cantidad, sortable: true, width: '10%' },
        { name: 'Valor', selector: row => row.valor, sortable: true, width: '10%' },
        { name: 'Observaciones', selector: row => row.observaciones, sortable: true, width: '55%' }
    ];
    useEffect(() => {
    
        const fetchData = async () => {
            let url = '/reincorporados/crearformulariodesembolso';
            let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setEntidades(result.entidades);
                setAyudas(result.ayudas);
                setIntegrantes(result.integrantesdto);
                ResetForm();
                setValue('usrId', user);
                setValue('cabIdcabezafamilia', idCabezaFamilia);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
            
            
        };
        fetchData();
    }, []);
    const onSubmit = async (data) => {
        const ExisteAtencion = getValues('desembolsosfields').find((item) => item.idayuda === data.ayuda && item.idpersona === data.idpersona);
        if(!ExisteAtencion){
            const nombreayuda = ayudas.find((item) => item.id === data.ayuda).ayuAyuda;
            const nombreentidad = entidades.find((item) => item.id === data.entidad).entEntidad;
            append({
                idayuda: data.ayuda, 
                ayuda: nombreayuda, 
                idpersona: data.idpersona, 
                identidad: data.entidad, 
                fecha: data.fecha,
                valor: data.valor,
                entidad: nombreentidad, 
                cantidad: data.cantidad, 
                observaciones: data.observaciones
            });
            ResetForm();
        }else {
            Mensaje('Registrar desembolso', "ya esta registrada este desembolso");
        }
        
    };
    const GuardarDesembolso = async () => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/reincorporados/registrardesembolso';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar desembolso', JSON.stringify(response.data));
                reset({
                    atencionesfields: []
                  });
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar desembolso', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar desembolso', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            ResetForm();
        }

      };
    const ResetForm = () => {
        const fechahoy = new Date()
        setValue('ayuda', "");
        setValue('entidad', 1);
        setValue('fecha', fechahoy);
        setValue('cantidad', '1');
        setValue('idpersona', '');
        setValue('valor', '');
        setValue('observaciones', "");
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Registrar desembolsos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Registrar desembolsos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuReincorporados idCabezaFamilia={idCabezaFamilia} />
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                            <DatosCabezaFamilia datos={cabezaFamiliaDatos}></DatosCabezaFamilia>
                            <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group" >
                                        <label>Entidad:</label>
                                        <select {...register('entidad', { required: true })} className='form-control' >
                                            {entidades.map((option) => (
                                            <option key={option.id} value={option.id}>
                                               {option.id} {option.entEntidad}
                                            </option>
                                            ))}
                                        </select>
                                        {errors.entidad && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                        <p>{entidad}</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group" >
                                        <label>Ayuda:</label>
                                        <select {...register('ayuda', { required: true })} className='form-control' >
                                            <option value="">Seleccionar</option>
                                            {ayudas.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.ayuAyuda}
                                            </option>
                                            ))}
                                        </select>
                                        {errors.ayuda && <p style={{color: 'red'}}>Seleccione atencion</p>}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group" >
                                        <label>Integrante:</label>
                                        <select {...register('idpersona', { required: true })} className='form-control' >
                                            <option value="">Seleccionar</option>
                                            {integrantes.map((option) => (
                                            <option key={option.per_idpersona} value={option.per_idpersona}>
                                                {option.par_parentesco} {option.per_idpersona} {option.nombre}
                                            </option>
                                            ))}
                                        </select>
                                        {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-md-4">
                                    <div className="form-group" >
                                        <label>Valor total</label>
                                        <input className="form-control" 
                                            {...register('valor', { required: true })}
                                            placeholder="valor"/>
                                        {errors.valor && <p style={{color: 'red'}}>Digite valor</p>}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group" >
                                        <label>Cantidad</label>
                                        <input className="form-control" 
                                            {...register('cantidad', { required: true })}
                                            placeholder="cantidad"/>
                                        {errors.cantidad && <p style={{color: 'red'}}>Digite cantidad</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Fecha atenci&oacute;n</label>
                                        <Controller
                                            
                                            control={control}
                                            name="fecha"
                                            render={({ field }) => (
                                                <DatePicker
                                                placeholderText="fecha"
                                                onChange={(date) => field.onChange(date)}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                selected={field.value}
                                                customInput={<CustomInput />}
                                                locale="es"
                                                dateFormat="yyyy-MM-dd"
                                                maxDate={new Date()}
                                                />
                                            )}
                                        />
                                        {errors.fecha && <p style={{color: 'red'}}>Digite fecha de atencion</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className='row'>
                                        <div className="col-md-12">
                                            <label htmlFor="observaciones">Observaciones</label>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12">
                                        <textarea rows={3} style={{ width: '100%' }}
                                            {...register('observaciones', { required: true })}
                                            placeholder="observaciones"
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-2">
                                    <button type="submit" className="btn btn-primary">Agregar</button>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="card-body table-responsive p-0">
                                        <DataTable
                                            title="Desembolsos"
                                            columns={columns}
                                            data={getValues('desembolsosfields')}    
                                            progressPending={Cargando}
                                            pagination
                                            noDataComponent="No hay datos para mostrar"
                                        /> 
                                    </div>
                                </div>
                            </div>
                            </div>
                            {/* /.card-body */}
                            {getValues('desembolsosfields') && getValues('desembolsosfields').length > 0 && (
                                <div className="card-footer">
                                    <button type="button" onClick={GuardarDesembolso} className="btn btn-primary">Guardar</button>
                                </div>
                            )}
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}